var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 152,
    viewBox: "0 0 134 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_373_19204)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_373_19204",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 8,
    width: 110,
    height: 128
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.468 135.694H22.5322C16.716 135.694 12 131.059 12 125.341V19.1092C12 13.3908 16.716 8.75513 22.5322 8.75513H111.468C117.284 8.75513 122 13.3908 122 19.1092V125.341C122 131.059 117.284 135.694 111.468 135.694Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_373_19204)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.468 135.694H22.5322C16.716 135.694 12 131.059 12 125.341V19.1092C12 13.3908 16.716 8.75513 22.5322 8.75513H111.468C117.284 8.75513 122 13.3908 122 19.1092V125.341C122 131.059 117.284 135.694 111.468 135.694Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7623 85.4081H70.4761V84.1807H61.7623V85.4081Z",
    fill: "#89C0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7736 101.365H79.1892V98.2964H28.7736V101.365Z",
    fill: "#89C0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7736 116.094H69.853V113.025H28.7736V116.094Z",
    fill: "#89C0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7736 108.729H53.0478V105.661H28.7736V108.729Z",
    fill: "#89C0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9752 75.9035H29.3948V86.0223H40.2792V84.4719H30.9752V75.9035ZM101.882 75.9035V84.4719H92.5784V86.0223H103.463V75.9035H101.882ZM29.3958 31.6996H30.9762V23.1331H40.2802V21.5828H29.3958V31.6996ZM92.5784 21.5828V23.133H101.882V31.6996H103.463V21.5828H92.5784Z",
    fill: "#89C0FF"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.983 100.621C97.1727 100.621 91.6552 106.138 91.6552 112.948C91.6552 119.758 97.1727 125.276 103.983 125.276C110.793 125.276 116.31 119.758 116.31 112.948C116.31 106.138 110.793 100.621 103.983 100.621ZM111.141 114.34C111.141 114.668 110.872 114.937 110.544 114.937H105.971V119.51C105.971 119.838 105.703 120.106 105.375 120.106H102.591C102.263 120.106 101.994 119.838 101.994 119.51V114.937H97.4213C97.0932 114.937 96.8248 114.668 96.8248 114.34V111.556C96.8248 111.228 97.0932 110.96 97.4213 110.96H101.994V106.387C101.994 106.059 102.263 105.79 102.591 105.79H105.375C105.703 105.79 105.971 106.059 105.971 106.387V110.96H110.544C110.872 110.96 111.141 111.228 111.141 111.556V114.34Z",
    fill: "#3063E4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0257 72.1305H88.6229V4.29932H44.0257V72.1305Z",
    fill: "#97B1F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.577 72.1305H88.6229V4.29932H67.577V72.1305Z",
    fill: "#648AEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5464 24.9935H57.5552V14.0715H53.5464V24.9935Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5464 68.6812H57.5552V57.7593H53.5464V68.6812Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.577 29.3047C67.577 29.3881 62.3043 29.4547 55.802 29.4547C49.2973 29.4547 44.0257 29.3881 44.0257 29.3047C44.0257 29.2225 49.2973 29.1553 55.802 29.1553C62.3043 29.1553 67.577 29.2225 67.577 29.3047Z",
    fill: "#FFFFFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5464 46.8375H57.5552V35.9155H53.5464V46.8375Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.577 51.1485C67.577 51.2318 62.3043 51.2985 55.802 51.2985C49.2973 51.2985 44.0257 51.2318 44.0257 51.1485C44.0257 51.0663 49.2973 50.999 55.802 50.999C62.3043 50.999 67.577 51.0663 67.577 51.1485Z",
    fill: "#FFFFFE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0878 24.9935H76.0966V14.0715H72.0878V24.9935Z",
    fill: "#97B1F1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1077 24.9935H85.1164V14.0715H81.1077V24.9935Z",
    fill: "#97B1F1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0878 46.2628H76.0966V35.3408H72.0878V46.2628Z",
    fill: "#97B1F1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1077 46.2628H85.1164V35.3408H81.1077V46.2628Z",
    fill: "#97B1F1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0878 67.5318H76.0966V56.6099H72.0878V67.5318Z",
    fill: "#97B1F1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1077 67.5318H85.1164V56.6099H81.1077V67.5318Z",
    fill: "#97B1F1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5187 4.29936H92.1313V2H40.5187V4.29936Z",
    fill: "#648AEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_373_19204",
    x: 0,
    y: 0.755127,
    width: 134,
    height: 150.939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_373_19204"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_373_19204",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.990f5227189a88f05b5b92335632e426.svg";
export { ForwardRef as ReactComponent };